// For full API documentation, including code examples, visit https://wix.to/94BuAAs
<meta name="google-site-verification" content="3w3O467kq3eM9lWXVepxHIgPEq9w_-06N_a3W3ZA0pw" />
$w.onReady(function () {
	//TODO: write your page related code here...

});